"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultFormattingPreferences = exports.formattingPreferencesDefaultValue = exports.formattingPreferencesSchema = void 0;
const zod_1 = require("zod");
exports.formattingPreferencesSchema = zod_1.z.object({
    decimal_separator: zod_1.z.string(),
});
const defaultPref = {
    decimal_separator: ',',
};
exports.formattingPreferencesDefaultValue = JSON.stringify(defaultPref);
const getDefaultFormattingPreferences = () => {
    return JSON.parse(exports.formattingPreferencesDefaultValue);
};
exports.getDefaultFormattingPreferences = getDefaultFormattingPreferences;
